exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-select-trigger{font-size: 15px !important;}\n.mat-error{font-size: 12px;}\n.outer_width{width:900px;}\n.mat-radio-label{white-space: normal;}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/admin/supplier-edit-activity/supplier-edit-activity.component.css
// module id = ../../../../../src/app/admin/supplier-edit-activity/supplier-edit-activity.component.css
// module chunks = 39